import React from 'react';
import config from '../config';
import DashboardInitializer from '../dashboards/DashboardInitializer';
import apiPaths from '../apiPaths';

const AppmenuDashboard = (props) => {
  const components = [
    {
      params: {
        type: 'search',
        componentId: 'appmenuappmenuSearch',
        panelHeader: 'Appmenu Search',
        panelKey: 'appmenuappmenuSearch',
        yPosition: 0,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabIndex: 0,
        tabTitle: '',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 0,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'displayorder',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'id',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'logo',
                  yPosition: 1,
                  xPosition: 3,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'name',
                  yPosition: 1,
                  xPosition: 4,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'optimistickLocking',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'parentId',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'swcheckwarning',
                  yPosition: 2,
                  xPosition: 3,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'swdisabled',
                  yPosition: 2,
                  xPosition: 4,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'swdisplaymenu',
                  yPosition: 3,
                  xPosition: 1,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'swwelcome',
                  yPosition: 3,
                  xPosition: 2,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
                {
                  key: 'url',
                  yPosition: 3,
                  xPosition: 3,
                  mustRender: true,
                  width: 6, //TODO hardcoded
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Displayorder',
          key: 'displayorder',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Id',
          key: 'id',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Logo',
          key: 'logo',
          type: 'text',
          operand: 'like',
          min: 0,
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Name',
          key: 'name',
          type: 'text',
          operand: 'like',
          min: 0,
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Optimistick Locking',
          key: 'optimistickLocking',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Parent Id',
          key: 'parentId',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Swcheckwarning',
          key: 'swcheckwarning',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Swdisabled',
          key: 'swdisabled',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Swdisplaymenu',
          key: 'swdisplaymenu',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Swwelcome',
          key: 'swwelcome',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Url',
          key: 'url',
          type: 'text',
          operand: 'like',
          min: 0,
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
      },
    },
    {
      params: {
        type: 'table',
        componentId: 'appmenuappmenuList',
        rowKey: 'id',
        panelHeader: 'Appmenu List',
        panelKey: 'appmenuappmenuList',
        navigationParams: props.query.params.q || '',
        yPosition: 1,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabTitle: '',
        isMainTable: true,
        tabIndex: 0,
        tableType: 0,
      },
      fields: [
        {
          title: 'Displayorder',
          dataIndex: 'displayorder',
          position: 0,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Id',
          dataIndex: 'id',
          position: 1,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Logo',
          dataIndex: 'logo',
          position: 2,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Name',
          dataIndex: 'name',
          position: 3,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Optimistick Locking',
          dataIndex: 'optimistickLocking',
          position: 4,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Parent Id',
          dataIndex: 'parentId',
          position: 5,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Swcheckwarning',
          dataIndex: 'swcheckwarning',
          position: 6,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Swdisabled',
          dataIndex: 'swdisabled',
          position: 7,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Swdisplaymenu',
          dataIndex: 'swdisplaymenu',
          position: 8,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Swwelcome',
          dataIndex: 'swwelcome',
          position: 9,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
        {
          title: 'Url',
          dataIndex: 'url',
          position: 10,
          mustRender: true,
          align: 'left',
          sorter: false,
          visible: true,
        },
      ],
      settings: {
        size: config.COMPONENT.TABLE.SIZE,
        bordered: config.COMPONENT.TABLE.BORDERED,
        editable: true,
        multiple: false,
        canCreate: true,
        canDelete: false,
        scroll: { x: true },
      },
      pagination: {
        defaultPageSize: 50,
        pageSizeOptions: ['5', '10', '20', '50'],
        showQuickJumper: config.COMPONENT.SHOW_QUICK_JUMPER,
        showSizeChanger: config.COMPONENT.TABLE.SHOW_SIZE_CHANGER,
        showTotal: config.COMPONENT.TABLE.SHOW_TOTAL,
        size: config.COMPONENT.TABLE.SIZE,
      },
    },
    {
      params: {
        type: 'edit',
        componentId: 'appmenuappmenuEdit',
        panelHeader: 'Appmenu Edit',
        panelKey: 'appmenuappmenuEdit',
        primaryKey: 'id',
        yPosition: 2,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: true,
        tabIndex: 0,
        tabTitle: 'Appmenu',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 2,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'displayorder',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'logo',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'name',
                  yPosition: 1,
                  xPosition: 3,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'optimistickLocking',
                  yPosition: 1,
                  xPosition: 4,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'parentId',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'swcheckwarning',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'swdisabled',
                  yPosition: 2,
                  xPosition: 3,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'swdisplaymenu',
                  yPosition: 2,
                  xPosition: 4,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'swwelcome',
                  yPosition: 3,
                  xPosition: 1,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'url',
                  yPosition: 3,
                  xPosition: 2,
                  mustRender: true,
                  width: 6,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Displayorder',
          key: 'displayorder',
          type: 'number',
          unique: false,
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Logo',
          key: 'logo',
          type: 'text',
          unique: false,
          min: 0,
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Name',
          key: 'name',
          type: 'text',
          unique: false,
          min: 0,
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Optimistick Locking',
          key: 'optimistickLocking',
          type: 'number',
          unique: false,
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Parent Id',
          key: 'parentId',
          type: 'number',
          unique: false,
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Swcheckwarning',
          key: 'swcheckwarning',
          type: 'comboCustom',
          comboId: 'corporate',
          unique: false,
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Swdisabled',
          key: 'swdisabled',
          type: 'comboCustom',
          comboId: 'corporate',
          unique: false,
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Swdisplaymenu',
          key: 'swdisplaymenu',
          type: 'comboCustom',
          comboId: 'corporate',
          unique: false,
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Swwelcome',
          key: 'swwelcome',
          type: 'comboCustom',
          comboId: 'corporate',
          unique: false,
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Url',
          key: 'url',
          type: 'text',
          unique: false,
          min: 0,
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
        canEdit: true,
        canCreate: true,
        canDelete: true,
      },
    },
  ];

  const componentId = 'AppmenuDashboard';

  return (
    <DashboardInitializer
      componentId={componentId}
      components={components}
      {...props}
    />
  );
};

export default AppmenuDashboard;
